import React from 'react';

import UserSkeleton from '~/boilerplates/User';
import Survey from '~/containers/User/CSAT/Survey';
import { SurveyContextProvider } from '~/contexts/CSAT/SurveyContext';
import { SurveyPrivilegesContextProvider } from '~/contexts/CSAT/SurveyPrivilegesContext';

export default function TeamsPage() {
  return (
    <UserSkeleton>
      <SurveyPrivilegesContextProvider>
        <SurveyContextProvider>
          <Survey />
        </SurveyContextProvider>
      </SurveyPrivilegesContextProvider>
    </UserSkeleton>
  );
}
